/* eslint-disable no-undef */
import { rootProps } from './root';

__webpack_public_path__ = rootProps.publicPath
  ? rootProps.publicPath
  : rootProps.scorm && !rootProps.lmsPreview
  ? `./`
  : process.env.PUBLIC_URL + '/';
/* eslint-enable no-undef */
